






















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class PatientAcquisitionExportationViewerPage extends Vue {
  @Prop({ required: true }) private page!: number;
  @Prop({ required: true }) private total!: number;

  // Necessary beacon to be detected by page counter
  type = 'page';

  get width() {
    const dpi = document.getElementById('export-dpi-sensor')!.clientWidth;
    return ((210 - 14 * 2) * dpi) / 25.4 + 'px';
  }
}
